module.exports = __webpack_public_path__ + "img/icon-empty-status.3ad07ba5.svg";